<template>
    <FormGroup
        :name="name"
        :label="label"
        :as-row="asRow"
        :size="size"
        :required="required"
        :errors="errors"
        :hide-validation="!showValidation">
        <template #default>
            <input
                ref="input"
                v-model="model"
                class="form-control"
                type="url"
                autocomplete="off"
                autocapitalize="none"
                spellcheck="false"
                maxlength="2000"
                :class="inputClass"
                :name="name"
                :required="required"
                v-bind="$attrs">
        </template>

        <template #tips>
            <slot />
        </template>
    </FormGroup>
</template>

<script>
import FieldMixin from '@/js/mixins/FieldMixin';

import FormGroup from '@/js/components/common/fields/FormGroup';

export default {
    name: 'UrlField',

    components: {FormGroup},

    mixins: [FieldMixin],

    inheritAttrs: false,

    props: {
        value: {type: String, default: null},
    },

    methods: {
        validate(value) {
            // STUB - you should overwrite it
            const errors = [];

            if (this.required && (value === null)) {
                errors.push(this.$t('validation.custom.required'));
            }

            if ((value !== null) && !this.isValidUrl(value)) {
                errors.push(this.$t('validation.custom.url'));
            }

            this.modelErrors = errors;
        },

        isValidUrl(url) {
            if (!window.URL) {
                // cannot validate on client
                return true;
            }

            try {
                new URL(url);
            } catch (exception) {
                return false;
            }

            return true;
        },
    },
};
</script>
